import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
export const StickyBottomMenu = JSX(() => (_jsx("div", { className: "hidden", role: "none" })));
//# sourceMappingURL=StickyBottomMenu.js.map